import { render, staticRenderFns } from "./bari.vue?vue&type=template&id=75b3aec1&scoped=true&"
import script from "./bari.vue?vue&type=script&lang=ts&"
export * from "./bari.vue?vue&type=script&lang=ts&"
import style0 from "./bari.vue?vue&type=style&index=0&id=75b3aec1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b3aec1",
  null
  
)

export default component.exports